// extracted by mini-css-extract-plugin
export default {"ButtonAdd":"BottoneVendita_ButtonAdd__b2nBS"};